import React from 'react';
import { useParams } from 'wouter';
import CostSavingsSummary from '../components/CostSavingsSummary';
import { ValueAssessmentProvider } from '../contexts/ValueAssessmentContext';

export default function CostSavingsSummaryPage() {
  const { projectId } = useParams<{ projectId: string }>();

  if (!projectId) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
        <div className="text-center space-y-4">
          <h2 className="text-xl font-semibold text-foreground">Invalid Project</h2>
          <p className="text-muted-foreground">No project ID provided in the URL.</p>
        </div>
      </div>
    );
  }

  return (
    <ValueAssessmentProvider>
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 px-4 sm:px-6 lg:px-8">
        <CostSavingsSummary 
          projectId={projectId} 
          isPublicView={false}
        />
      </div>
    </ValueAssessmentProvider>
  );
}